
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'InfoNav',
  setup() {
    // 导航栏内容
    const tags = [
      {
        icon: 'el-icon-user-solid',
        index: 'person_info',
        title: '个人信息',
      },
      {
        icon: 'el-icon-s-order',
        index: 'all_order',
        title: '订单服务',
      },
    ];
    return {
      tags,
    };
  },
});
